import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3320 6165 l0 -1775 1815 0 1815 0 0 1775 0 1775 -1815 0 -1815 0 0
-1775z m1765 1320 c141 -20 245 -50 335 -95 184 -92 339 -263 400 -440 14 -41
29 -77 32 -80 3 -3 73 58 154 136 82 78 228 216 324 307 l175 165 3 -258 2
-258 -553 -554 c-475 -475 -565 -560 -635 -603 -44 -27 -81 -53 -82 -56 0 -4
73 -87 162 -185 157 -174 515 -581 612 -696 l48 -58 -274 0 -275 0 -199 233
c-262 305 -482 528 -594 600 -79 51 -214 117 -239 117 -8 0 -11 59 -11 184 l0
184 318 4 c294 5 321 7 377 27 125 45 232 146 275 258 32 81 39 231 15 319
-32 117 -119 225 -229 281 -95 48 -146 53 -623 53 l-443 0 0 -1130 0 -1130
-205 0 -205 0 0 1345 0 1345 618 0 c484 0 639 -3 717 -15z m1401 -1459 c-37
-47 -623 -636 -632 -636 -12 0 -254 242 -254 254 0 7 96 123 120 146 3 3 36
41 74 85 62 72 145 162 361 395 38 41 132 139 210 218 l140 142 3 -286 2 -287
-24 -31z m24 -781 l0 -435 -64 0 c-62 0 -64 1 -101 43 -38 43 -106 114 -250
265 l-80 84 245 239 c135 131 246 239 248 239 1 0 2 -196 2 -435z"
          />
          <path
            d="M1240 3047 l0 -385 70 -4 70 -3 0 153 0 152 74 0 c61 0 75 -3 80 -17
5 -13 128 -242 151 -280 3 -5 175 -16 175 -11 0 3 -39 74 -86 159 -99 177
-100 179 -84 179 7 0 32 12 56 27 139 88 118 310 -35 382 -53 24 -66 25 -263
29 l-208 4 0 -385z m355 253 c78 -18 119 -101 79 -158 -29 -42 -65 -52 -184
-52 l-110 0 0 110 0 110 88 0 c48 0 105 -5 127 -10z"
          />
          <path
            d="M2220 3343 c-18 -49 -86 -223 -151 -387 -65 -165 -118 -301 -116
-302 1 -1 38 1 83 3 l80 5 31 87 30 86 144 3 144 3 33 -90 c33 -86 34 -89 70
-95 20 -3 57 -6 81 -6 41 0 43 1 37 26 -4 14 -40 110 -80 212 -41 103 -104
267 -142 365 l-67 177 -72 0 -72 0 -33 -87z m194 -360 c7 -23 6 -23 -88 -23
-53 0 -96 4 -96 8 0 8 71 220 85 256 6 14 19 -12 50 -100 23 -66 45 -129 49
-141z"
          />
          <path
            d="M2810 3045 l0 -385 75 0 75 0 0 155 0 155 185 0 185 0 0 -157 0 -158
72 2 73 1 0 384 0 383 -72 3 -73 3 0 -161 0 -160 -185 0 -185 0 0 160 0 160
-75 0 -75 0 0 -385z"
          />
          <path
            d="M3903 3413 c-3 -10 -32 -83 -64 -163 -62 -155 -153 -391 -196 -505
-15 -38 -32 -76 -37 -84 -9 -12 -6 -13 14 -8 14 4 53 7 86 7 l61 0 32 90 33
90 143 0 144 0 19 -52 c11 -29 25 -69 31 -89 10 -31 17 -37 49 -43 44 -7 132
-8 132 -1 0 2 -29 80 -65 172 -36 92 -100 256 -141 363 -41 107 -79 205 -84
218 -9 20 -16 22 -80 22 -58 0 -72 -3 -77 -17z m130 -320 l45 -133 -99 0 c-54
0 -99 2 -99 4 0 2 20 59 45 127 25 68 45 131 45 139 0 31 19 -10 63 -137z"
          />
          <path
            d="M4500 3393 c0 -21 -4 -119 -9 -218 -6 -99 -13 -255 -16 -347 l-7
-168 70 0 70 0 8 168 c4 92 8 206 8 254 1 49 2 88 3 88 1 0 12 -21 24 -47 11
-27 61 -136 110 -244 49 -108 89 -202 89 -208 0 -6 18 -11 44 -11 41 0 45 2
55 33 6 18 56 133 110 255 112 254 111 254 111 27 0 -66 3 -164 7 -217 l6 -96
70 -4 69 -3 -6 95 c-3 52 -9 227 -12 388 l-7 292 -88 0 -89 0 -23 -47 c-13
-27 -61 -138 -107 -248 -46 -110 -87 -204 -91 -209 -4 -5 -15 9 -24 30 -8 22
-57 137 -108 257 l-92 217 -87 0 -88 0 0 -37z"
          />
          <path
            d="M5743 3413 c-4 -10 -44 -115 -90 -233 -178 -456 -204 -523 -201 -525
2 -2 39 0 82 3 l79 7 29 80 c15 43 32 83 36 87 5 5 71 7 147 6 l138 -3 31 -85
c28 -76 35 -86 61 -91 38 -8 135 -11 135 -4 0 7 -160 425 -236 617 -30 75 -54
142 -54 147 0 7 -29 11 -75 11 -63 0 -77 -3 -82 -17z m90 -195 c4 -20 63 -191
82 -240 7 -16 -2 -18 -95 -18 -93 0 -102 2 -95 18 4 9 26 72 49 139 22 67 44
122 47 123 4 0 9 -10 12 -22z"
          />
          <path
            d="M6330 3429 c0 -2 -1 -176 -3 -387 l-2 -382 170 0 c112 0 188 5 221
14 133 35 224 121 265 248 18 58 21 83 16 158 -7 112 -39 181 -114 250 -83 76
-139 91 -365 97 -104 3 -188 4 -188 2z m389 -156 c184 -94 166 -389 -28 -471
-20 -8 -75 -17 -123 -20 l-88 -5 0 268 0 268 92 -6 c74 -5 103 -12 147 -34z"
          />
          <path
            d="M7329 3403 c-6 -15 -52 -134 -103 -263 -169 -428 -189 -480 -185
-484 2 -1 39 -1 81 2 l77 4 26 77 c14 42 29 82 33 89 7 9 44 12 152 10 l143
-3 30 -85 c17 -47 31 -86 32 -87 2 -5 165 -15 165 -11 0 3 -30 81 -66 174 -36
93 -72 186 -80 207 -8 20 -21 54 -29 75 -8 20 -38 100 -68 177 l-54 140 -72 3
c-70 3 -71 2 -82 -25z m132 -309 l47 -134 -99 0 c-54 0 -99 2 -99 4 0 2 20 59
45 127 25 68 45 130 45 138 0 30 16 -5 61 -135z"
          />
          <path
            d="M7740 3370 l0 -59 121 -3 121 -3 -2 -322 -1 -323 76 0 75 0 0 325 0
325 125 0 125 0 0 60 0 60 -320 0 -320 0 0 -60z"
          />
          <path
            d="M8611 3408 c-5 -13 -23 -59 -41 -103 -18 -44 -56 -141 -85 -215 -29
-74 -78 -199 -109 -277 -31 -79 -56 -148 -56 -154 0 -7 9 -9 23 -5 12 3 48 6
79 6 l56 0 26 78 c15 42 30 83 34 90 7 9 44 12 152 10 l143 -3 31 -85 c35 -95
38 -96 144 -99 51 -1 53 0 47 22 -7 22 -42 113 -208 537 l-83 215 -72 3 c-67
3 -73 1 -81 -20z m125 -291 c23 -67 45 -130 49 -139 7 -16 -2 -18 -94 -18 -56
0 -101 2 -101 4 0 2 20 59 45 127 25 68 45 130 45 137 0 36 19 -1 56 -111z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
